import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import TopicGrid from '@/pages/home/components/TopicGrid';
import CourseGridSection from '@/pages/home/components/CourseGridSection';
import IntroSection from '@/pages/home/components/IntroSection';
import SectionHeading from '@/components/base/SectionHeading';
import { getHotCourses, getLatestCourses } from '@/utils/course';

export default function Home() {
  const latestCourses = getLatestCourses(8);
  const hotCourses = getHotCourses(4);

  return (
    <div className="w-full">
      <HeroCarousel />

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="热门领域"
          title="按分类探索课程"
          desc="覆盖语言、技术、财经等六大领域，快速找到适合你的学习方向。"
          viewAllTo="/category"
          viewAllLabel="全部课程"
        />
        <CategoryGrid />
      </section>

      <section className="w-full bg-background-50 border-y border-background-200">
        <div className="px-4 md:px-8 py-10 md:py-14">
          <CourseGridSection
            eyebrow="新鲜出炉"
            title="最新发布课程"
            desc="本周上新的优质课程，抢先体验前沿内容与实战方法。"
            courses={latestCourses}
            viewAllTo="/category?sort=latest"
          />
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <CourseGridSection
          eyebrow="大家都在学"
          title="热门课程推荐"
          desc="基于学习热度与好评度精选，跟着大多数人一起高效提升。"
          courses={hotCourses}
          viewAllTo="/category?sort=views"
        />
      </section>

      <section id="topics" className="w-full bg-background-50 border-y border-background-200 scroll-mt-20">
        <div className="px-4 md:px-8 py-10 md:py-14">
          <SectionHeading
            eyebrow="系统专题"
            title="教育专题集合"
            desc="围绕特定学习目标精心策划的课程合集，成体系地补齐你的知识拼图。"
          />
          <TopicGrid />
        </div>
      </section>

      <div className="py-10 md:py-14">
        <IntroSection />
      </div>
    </div>
  );
}